import React, { Component } from 'react'
import { ToastContainer, toast } from 'react-toastify';
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";




export class EditProperty extends Component {
  render() {
    return (
      <div>EditProperty</div>
    )
  }
}

export default EditProperty


export function EditPropertyc(props){
  const navigate = useNavigate();
  const location = useLocation();
  const param = useParams()
  return (<EditProperty param={param} navigate={navigate}></EditProperty>)}